import React, { useState, useEffect, useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Box,
    Tooltip
} from '@mui/material';
import { useMaterialReactTable } from 'material-react-table';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import OutboundOutlinedIcon from '@mui/icons-material/OutboundOutlined';
import OutboundIcon from '@mui/icons-material/Outbound';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
    AddBox as AddBoxIcon,
} from '@mui/icons-material';
import InventoryIcon from '@mui/icons-material/Inventory';

import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../assets/imgs/office.png';

import VerifiedIcon from '@mui/icons-material/Verified'; // ícone sugestão (pode trocar)
import { Delete } from '@material-ui/icons';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import AssignmentIcon from '@mui/icons-material/Assignment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Skeleton from '@material-ui/lab/Skeleton';
import CancelIcon from '@mui/icons-material/Cancel';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import EditNoteIcon from '@mui/icons-material/EditNote';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useTheme } from "@mui/material/styles";
import MenuIcon from '@mui/icons-material/Menu';
import {
    Card,
    Divider
} from "@mui/material";
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import moment from 'moment'; // Importe a biblioteca Moment.js
import { SwipeableDrawer, Drawer, List, ListItem, ListItemText, ListItemIcon, useMediaQuery } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PaidIcon from '@mui/icons-material/Paid';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import api from '../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import LinkIcon from '@mui/icons-material/Link';

import Rodape from '../../../../../components/Rodape';
import {
    MaterialReactTable,

} from 'material-react-table';
import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CircularProgress, DialogActions, DialogContentText } from '@mui/material';

import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Snackbar, Alert, Backdrop } from '@mui/material';
import DashboardGeral from './DashboardGeral'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import OrdemCompraComponente from './ordemCompraComponente';
const drawerWidth = 240;



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));



export default function OrdensDeCompras() {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md")); // mobile/tablet até md

    const [darkMode, setDarkMode] = useState(isMobile || Cookies.get('darkMode') === 'true');
    const [open, setOpen] = useState(false);
    const touchStartRef = useRef(null);


    const themeTabela = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            ...(darkMode && {
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
            }),
        },
        components: {
            MuiTablePagination: {
                styleOverrides: {
                    root: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    selectLabel: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    displayedRows: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
            MuiSelect: {
                styleOverrides: {
                    icon: {
                        color: darkMode ? '#fff' : '#000',
                    },
                    select: {
                        color: darkMode ? '#fff' : '#000',
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        // Não forçar cor global aqui para não sobrescrever ícones de status
                        // A cor dos botões da toolbar é controlada via muiTopToolbarProps
                    },
                },
            },
        },
    });


    // --- LÓGICA DE DARK MODE ---
    const [headerBackgroundColor, setHeaderBackgroundColor] = useState(darkMode ? '#1e1e1e' : '#fff');
    const [headerTextColor, setHeaderTextColor] = useState(darkMode ? '#fff' : '#000');
    const [rowBackgroundColor, setRowBackgroundColor] = useState(darkMode ? '#2d2d2d' : '#fff');
    const [rowTextColor, setRowTextColor] = useState(darkMode ? '#fff' : '#000');

    useEffect(() => {
        const handleDarkModeChange = () => {
            const isDark = isMobile || Cookies.get('darkMode') === 'true'; // Force dark on mobile
            setDarkMode(isDark);
            setHeaderBackgroundColor(isDark ? '#1e1e1e' : '#fff');
            setHeaderTextColor(isDark ? '#fff' : '#000');
            setRowBackgroundColor(isDark ? '#2d2d2d' : '#ffffff');
            setRowTextColor(isDark ? '#fff' : '#000');
        };

        window.addEventListener('darkModeChanged', handleDarkModeChange);

        // Inicializa estado
        const currentDarkMode = isMobile || Cookies.get('darkMode') === 'true'; // Force dark on mobile
        setDarkMode(currentDarkMode);
        setHeaderBackgroundColor(currentDarkMode ? '#1e1e1e' : '#fff');
        setHeaderTextColor(currentDarkMode ? '#fff' : '#000');
        setRowBackgroundColor(currentDarkMode ? '#2d2d2d' : '#ffffff');
        setRowTextColor(currentDarkMode ? '#fff' : '#000');

        return () => {
            window.removeEventListener('darkModeChanged', handleDarkModeChange);
        };
    }, []);

    // --- FIM DW DARK MODE ---

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const regra = Cookies.get("regra") || "";
    const ordemCompraRef = useRef(null);


    const [autorizadasChecked, setAutorizadasChecked] = useState(() => {
        if (regra.includes("ADMIN_OC_AUTORIZADAS")) {
            return true; // força sempre true
        }

        const cookie = Cookies.get("filtro_ordem_compra_autorizadas");
        return cookie ? cookie === "true" : false; // se não existir, false
    });

    const [filtroChecked, setFiltroChecked] = useState(() => {
        if (regra.includes("ADMIN_OC_MINHAS_OCS")) {
            return true; // força sempre true
        }

        const cookie = Cookies.get("filtro_ordem_compra");
        return cookie ? cookie === "true" : true; // se não existir, true
    });

    const [aguardandoChecked, setAguardandoChecked] = useState(() => {
        const cookie = Cookies.get("filtro_ordem_compra_aguardando");
        return cookie ? cookie === "true" : false; // se não existir, false
    });

    const [abertasChecked, setAbertasChecked] = useState(() => {
        const cookie = Cookies.get("filtro_ordem_compra_abertas");
        return cookie ? cookie === "true" : true; // se não existir, true
    });

    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [height, setHeight] = useState(0);

    const [tableHeight, setTableHeight] = useState(400); // valor inicial qualquer

    useEffect(() => {
        const updateHeight = () => {
            // No desktop o navbar e stats ocupam mais espaço vertical.
            // No mobile o topo é reduzido (10px quando fechado).
            const offset = isMobile ? 140 : 210;
            setTableHeight(window.innerHeight - offset);
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => window.removeEventListener('resize', updateHeight);
    }, [isMobile]);


    const [value, setValue] = useState(1);
    const [objetos, setObjetos] = useState(null);


    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 30,
    });

    const [totalRegistros, setTotalRegistros] = useState(0);
    const [filtro, setFiltro] = useState("");


    function checkDimenssoes() {

        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;


        setHeight(altura * 0.75);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    const [numOrdensAbertas, setNumOrdensAbertas] = useState(0);
    const [numOrdensAguardando, setNumOrdensAguardando] = useState(0);
    const [numOrdensSolicitante, setNumOrdensSolicitante] = useState(0);
    const [numOrdensAutorizador, setNumOrdensAutorizador] = useState(0);

    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get(`v1/protected/ordensdecompras/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}&idcolaborador=0`, {
                headers: headers
            }).then(function (response) {
                console.log("aqui 0");

                // === INÍCIO DA LÓGICA DE CONTAGEM ===
                let contAbertas = 0;
                let contAguardando = 0;
                let contSolicitante = 0;
                let contAutorizador = 0;

                response.data.dados.forEach((ordem_compra) => {
                    const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10);
                    const status = parseInt(ordem_compra.status, 10);

                    if (ordem_compra.solicitantes?.some(s => parseInt(s.id_usuario, 10) === id_usuario_logado)) contSolicitante++;
                    if (ordem_compra.autorizacoes?.some(a => parseInt(a.id_usuario, 10) === id_usuario_logado)) contAutorizador++;
                    if (status <= 1) contAbertas++;
                    if (status === 2) contAguardando++;
                });

                setNumOrdensAbertas(contAbertas);
                setNumOrdensAguardando(contAguardando);
                setNumOrdensSolicitante(contSolicitante);
                setNumOrdensAutorizador(contAutorizador);
                // === FIM DA LÓGICA DE CONTAGEM ===

                if (filtroChecked || regra.includes("ADMIN_OC_MINHAS_OCS") || regra.includes("ADMIN_OC_AUTORIZADAS") || autorizadasChecked || abertasChecked || aguardandoChecked) {
                    console.log("aqui 1");
                    const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10); // força para inteiro

                    const dadosOriginais = response.data.dados;
                    console.log("aqui 2");

                    const dadosFiltrados = dadosOriginais.filter((ordem_compra) => {

                        if (filtroChecked || regra.includes("ADMIN_OC_MINHAS_OCS")) {
                            // Verifica se o usuário logado é o criador
                            if (parseInt(ordem_compra.usuario?.id_usuario, 10) === id_usuario_logado

                            ) {

                                console.log("Na OC " + ordem_compra.id_ordem_compra +
                                    " status " + ordem_compra.status +

                                    " sou o criador")


                                if (abertasChecked) {
                                    console.log("aberta esta checked")

                                    const status = parseInt(ordem_compra.status, 10);
                                    if (status <= 1) {
                                        console.log(ordem_compra.id_ordem_compra + " tem status <= 1, retornando")
                                        return true;
                                    }
                                }

                                if (aguardandoChecked) {
                                    console.log("aguardando esta checked")

                                    const status = parseInt(ordem_compra.status, 10);
                                    if (status === 2) {
                                        return true;
                                    }
                                }
                                if (autorizadasChecked || regra.includes("ADMIN_OC_AUTORIZADAS")) {
                                    console.log("Na OC " + ordem_compra.id_ordem_compra)
                                    const status = parseInt(ordem_compra.status, 10);
                                    console.log(" status é " + status);
                                    if (status >= 3) {
                                        console.log("| retornando");
                                        return true;
                                    }
                                }
                                if (!abertasChecked && !aguardandoChecked && !autorizadasChecked && !regra.includes("ADMIN_OC_AUTORIZADAS"))
                                    return true;
                                else
                                    return false;
                            }

                            // Verifica se o usuário logado está na lista de solicitantes
                            if (ordem_compra.solicitantes?.some(
                                solicitante => parseInt(solicitante.id_usuario, 10) === id_usuario_logado

                            )) {


                                if (abertasChecked) {
                                    const status = parseInt(ordem_compra.status, 10);
                                    if (status <= 1) {
                                        return true;
                                    }
                                }

                                if (aguardandoChecked) {
                                    const status = parseInt(ordem_compra.status, 10);
                                    if (status === 2) {
                                        return true;
                                    }
                                }
                                if (autorizadasChecked || regra.includes("ADMIN_OC_AUTORIZADAS")) {
                                    console.log("Na OC " + ordem_compra.id_ordem_compra)
                                    const status = parseInt(ordem_compra.status, 10);
                                    console.log(" status é " + status);
                                    if (status >= 3) {
                                        console.log("| retornando");
                                        return true;
                                    }
                                }

                            }

                            // Verifica se o usuário logado está na lista de autorizações pendente de autorizacao
                            if (ordem_compra.autorizacoes?.some(
                                solicitante => parseInt(solicitante.id_usuario, 10) === id_usuario_logado

                            )) {
                                console.log("na oc " + ordem_compra.id_ordem_compra + " sou um dos autorizador, é o status é " + ordem_compra.status)

                                if (abertasChecked) {
                                    const status = parseInt(ordem_compra.status, 10);
                                    if (status <= 1) {
                                        return true;
                                    }
                                } else {
                                    console.log(" abertas nao esta checked")

                                }

                                if (aguardandoChecked) {
                                    console.log("aguardando esta checkado")
                                    const status = parseInt(ordem_compra.status, 10);
                                    if (status === 2) {
                                        console.log("o status é 2, retornando")
                                        return true;
                                    }
                                } else {
                                    console.log(" aguardando nao esta checked")

                                }
                                if (autorizadasChecked || regra.includes("ADMIN_OC_AUTORIZADAS")) {
                                    console.log("Na OC " + ordem_compra.id_ordem_compra)
                                    const status = parseInt(ordem_compra.status, 10);
                                    console.log(" status é " + status);
                                    if (status >= 3) {
                                        console.log("| retornando");
                                        return true;
                                    }
                                } else {
                                    console.log("autorizadas nao esta checked")

                                }

                            }
                            //nao sou o criador, nao sou o solicitante, nem o autorizador
                            console.log(ordem_compra.id_ordem_compra + " nao sou o criador, sem solicitante, nem autorizador")
                            if (regra.includes("ADMIN_OC_MINHAS_OCS")) {
                                if (ordem_compra.tipo_ordem === 0) {
                                    console.log(ordem_compra.id_ordem_compra + " é uma oc")
                                    if (regra.includes("ADMIN_OC_COMPRAS_ALMOXARIFADO")) {
                                        console.log("o usuario tem o admin ver compras do almoxarifado")

                                        if (abertasChecked) {
                                            const status = parseInt(ordem_compra.status, 10);
                                            if (status <= 1) {
                                                return true;
                                            }
                                        } else {
                                            console.log(" abertas nao esta checked")

                                        }

                                        if (aguardandoChecked) {
                                            console.log("aguardando esta checkado")
                                            const status = parseInt(ordem_compra.status, 10);
                                            if (status === 2) {
                                                console.log("o status é 2, retornando")
                                                return true;
                                            }
                                        } else {
                                            console.log(" aguardando nao esta checked")

                                        }
                                        if (autorizadasChecked || regra.includes("ADMIN_OC_AUTORIZADAS")) {
                                            console.log("Na OC " + ordem_compra.id_ordem_compra)
                                            const status = parseInt(ordem_compra.status, 10);
                                            console.log(" status é " + status);
                                            if (status >= 3) {
                                                console.log("| retornando");
                                                return true;
                                            }
                                        } else {
                                            console.log("autorizadas nao esta checked")

                                        }




                                    }
                                }

                                if (ordem_compra.tipo_ordem === 1) {
                                    console.log(ordem_compra.id_ordem_compra + " é um pagamento")
                                    if (regra.includes("ADMIN_OC_PAGAMENTOS")) {
                                        console.log("ver pagamentos esta marcado, retornando ")

                                        if (abertasChecked) {
                                            const status = parseInt(ordem_compra.status, 10);
                                            if (status <= 1) {
                                                return true;
                                            }
                                        } else {
                                            console.log(" abertas nao esta checked")

                                        }

                                        if (aguardandoChecked) {
                                            console.log("aguardando esta checkado")
                                            const status = parseInt(ordem_compra.status, 10);
                                            if (status === 2) {
                                                console.log("o status é 2, retornando")
                                                return true;
                                            }
                                        } else {
                                            console.log(" aguardando nao esta checked")

                                        }
                                        if (autorizadasChecked || regra.includes("ADMIN_OC_AUTORIZADAS")) {
                                            console.log("Na OC " + ordem_compra.id_ordem_compra)
                                            const status = parseInt(ordem_compra.status, 10);
                                            console.log(" status é " + status);
                                            if (status >= 3) {
                                                console.log("| retornando");
                                                return true;
                                            }
                                        } else {
                                            console.log("autorizadas nao esta checked")

                                        }


                                    }
                                }
                            }





                            return false;
                        } //fim de minhas ocs
                        if (abertasChecked) {
                            const status = parseInt(ordem_compra.status, 10);
                            if (status <= 1) {
                                return true;
                            }
                        }
                        if (aguardandoChecked) {
                            const status = parseInt(ordem_compra.status, 10);
                            if (status === 2) {
                                return true;
                            }
                        }

                        if (autorizadasChecked || regra.includes("ADMIN_OC_AUTORIZADAS")) {
                            console.log("Na OC " + ordem_compra.id_ordem_compra)
                            const status = parseInt(ordem_compra.status, 10);
                            console.log(" status é " + status);
                            if (status >= 3) {
                                console.log("| retornando");
                                return true;
                            }
                        }

                        return false;
                    });

                    console.log("aqui 3");

                    if (id_usuario_logado === 9 || id_usuario_logado === 8) {

                        const ordenados = [...dadosFiltrados].sort((a, b) => {
                            // 1) Ordenar por tipo_ordem (1 primeiro, depois 0)
                            if (a.tipo_ordem !== b.tipo_ordem) {
                                return b.tipo_ordem - a.tipo_ordem;
                                // b - a => coloca 1 antes de 0
                            }

                            // 2) Se tipo_ordem for igual, ordenar por id_ordem_compra
                            return a.id_ordem_compra - b.id_ordem_compra;
                        });

                        setObjetos(ordenados);
                        setTotalRegistros(ordenados.length);

                    } else {
                        setObjetos(dadosFiltrados);
                        setTotalRegistros(dadosFiltrados.length);
                    }
                    console.log("aqui 4");

                } else {

                    setObjetos(response.data.dados);
                    setTotalRegistros(response.data.total);
                }
                setLoading(false);
                console.log("aqui 5");


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }

    useEffect(() => {

        checkDimenssoes();
        // listar();
    }, []);




    function handleFiltroChecked(v) {
        setFiltroChecked(v);
        Cookies.set("filtro_ordem_compra", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }




    // Se quiser garantir que o estado sempre sincronize quando carregar
    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra");
        if (savedFiltro !== undefined) {
            setFiltroChecked(savedFiltro === "true");
        }
    }, []);





    function handleAutorizadasChecked(v) {
        setAutorizadasChecked(v);
        Cookies.set("filtro_ordem_compra_autorizadas", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }

    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra_autorizadas");
        if (savedFiltro !== undefined) {
            setAutorizadasChecked(savedFiltro === "true");
        }
    }, []);





    function handleAbertasChecked(v) {
        setAbertasChecked(v);
        Cookies.set("filtro_ordem_compra_abertas", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }

    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra_abertas");
        if (savedFiltro !== undefined) {
            setAbertasChecked(savedFiltro === "true");
        }
    }, []);





    function handleAguardandoChecked(v) {
        setAguardandoChecked(v);
        Cookies.set("filtro_ordem_compra_aguardando", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }

    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra_aguardando");
        if (savedFiltro !== undefined) {
            setAguardandoChecked(savedFiltro === "true");
        }
    }, []);




    useEffect(() => {

        listar();


    }, [filtroChecked, autorizadasChecked, aguardandoChecked, abertasChecked, pagination.size, pagination.index]);

    function novo() {
        window.location.href = "/gestao/administracao/ordensdecompras/cadastrarordemcompra"

    }





    const handleClickEdicao = (row) => {


        window.location.href = "/gestao/administracao/ordensdecompras/editar/" + row.id_ordem_compra;


    };



    function formatDate(date) {
        // Formate a data para 'HH:mm DD/MMM/YYYY'
        return moment(date).format('HH:mm DD/MM/YYYY');
    }






    const handleMenuClick = (newValue) => {
        if (newValue === 0) {

        } else if (newValue === 1) {

            ordemCompraRef.current?.listar();
        } else if (newValue === 2) {


        }
        setValue(newValue);
    };



    const [idOrdemCompraAutorizar, setIdOrdemCompraAutorizar] = useState(0);

    const [openBack, setOpenBack] = useState(false)
    async function handleClickReforcarAutorizacao(idOrdemCompraAutorizar) {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            // Chamada ao endpoint
            const response = await api.get(
                `/v1/protected/ordensdecompras/ordemdecompra/reforcarautorizacao/${idOrdemCompraAutorizar}`,
                { headers: headers }
            );

            const retorno = response.data; // será "Fora de Status" ou "Enviado"

            // Tratar resposta
            if (retorno === "Enviado") {
                // Mensagem de sucesso
                alert("Notificações enviadas para os autorizantes pendentes!");
                // Aqui você pode atualizar a tabela ou interface, se necessário
                // ex: atualizarStatusTabela(idOrdemCompraAutorizar);
            } else if (retorno === "Fora de Status") {
                // Mensagem de alerta
                alert("A ordem de compra não está no status correto para reforçar autorização.");
            } else {
                // Qualquer outro retorno inesperado
                console.warn("Retorno inesperado do servidor:", retorno);
            }

        } catch (err) {
            console.error("Erro ao reforçar autorização:", err);
            alert("Ocorreu um erro ao tentar reforçar a autorização. Verifique o console.");
        }
    }




    async function handleClickClonar(idOrdemClonar) {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            // Chamada ao endpoint
            const response = await api.get(
                `/v1/protected/ordensdecompras/ordemdecompra/clonar/${idOrdemClonar}`,
                { headers: headers }
            );

            if (response) {
                const id = response.data.id_ordem_compra;

                window.open(
                    `/gestao/administracao/ordensdecompras/editar/${id}`,
                    "_blank"
                );
            }

        } catch (err) {
            console.error("Erro ao reforçar autorização:", err);
            alert("Ocorreu um erro ao tentar clonar a Ordem de Compra. Contacte o Administrador do Sistema");
        }
    }




    async function handleClickRemover(row) {


        if (parseInt(row.usuario.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)) {

        } else {
            alert("Somente o criador da Ordem de Compra pode realizar essa ação!");
            return;
        }


        const confirmacao = window.confirm(
            "Tem certeza que deseja excluir esta Ordem de Compra?\nEssa ação não poderá ser desfeita."
        );

        if (!confirmacao) {
            return; // usuário cancelou
        }

        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            // Chamada ao endpoint
            const response = await api.delete(
                `/v1/protected/ordensdecompras/ordemdecompra/excluir/${row.id_ordem_compra}/${Cookies.get("id_usuario")}`,
                { headers }
            );

            const retorno = response.data;

            if (retorno) {
                alert("✅ Ordem de Compra excluída com sucesso!");
            } else {
                alert("⚠️ Erro ao excluir! Contate o administrador do sistema.");
            }

        } catch (err) {
            console.error("Erro ao excluir ordem de compra:", err);
            alert("❌ Ocorreu um erro ao tentar excluir a ordem de compra. Verifique o console.");
        }
    }


    const handleOpenAutorizar = (id) => {
        console.log("open autorizar chamado!");
        setIdOrdemCompraAutorizar(id);
        setOpenAutorizar(true);
    }

    const [openAutorizar, setOpenAutorizar] = useState(false)
    const [codigoValidacao, setCodigoValidacao] = useState("");
    const [open2, setOpen2] = useState(false);

    function handleCloseOpenAutorizar() {
        setIdOrdemCompraAutorizar(0);
        setOpenAutorizar(false);

    }


    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const gerarLancamento = (id) => {
        window.open(
            "/gestao/financas/lancamento/cadastrar?idprecotacao=" + id,
            "_blank"
        );
    };

    async function autorizar() {
        try {
            const id_usuario = Cookies.get('id_usuario');

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const valido = true; // aqui você valida o código se quiser

            if (valido) {
                const response = await api.put(
                    `/v1/protected/ordensdecompras/ordemdecompra/autorizar/${idOrdemCompraAutorizar}/${id_usuario}`,
                    { headers: headers }
                );

                const cadastro_salvo = response.data;

                if (cadastro_salvo) {
                    // FECHA DIALOG E BACKDROP
                    setOpenAutorizar(false);
                    setOpenBack(false);

                    // MOSTRA TOAST
                    setToastMessage("Autorização Concluída");
                    setToastOpen(true);

                    // ATUALIZA LISTAGEM
                    listar();
                } else {
                    setOpenBack(false);
                    setToastMessage("Erro de Conexão, tente novamente mais tarde");
                    setToastOpen(true);
                }
            } else {
                setOpen2(false);
                setToastMessage("Código Inválido!");
                setToastOpen(true);
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            setOpen2(false);
            setToastMessage("Erro de Conexão, tente novamente mais tarde");
            setToastOpen(true);
        }
    }


    const gerarEntradaEstoque = (id) => {
        window.open(
            "/gestao/operacional/almoxarifado/entradaestoque/cadastrarentradaestoque?id-pre-cotacao=" + id,
            "_blank"
        );
    };


    const gerarSaidaEstoque = (id) => {
        window.open(
            "/gestao/operacional/almoxarifado/saidaestoque/cadastrarsaidaestoque?id-ordem-compra=" + id,
            "_blank"
        );
    };

    const STATUS_TEXT = {
        "-2": "Suprido via Estoque",
        0: "Editando",
        1: "Aguardando Escolha de Cotação",
        2: "Aguardando Autorização",
        3: "Autorizado, em Faturamento",
        4: "Recebimento Concluído",
        9: "Cancelada",
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_ordem_compra',
                header: 'ID',
                size: 50,
            },
            {
                accessorFn: (row) => row.nivel_prioridade,
                id: 'nivel_prioridade',
                header: '🔺',
                size: 50,
                Cell: ({ renderedCellValue }) => {
                    let icon = null;
                    let title = '';

                    switch (renderedCellValue) {
                        case 0:
                            icon = <LowPriorityIcon sx={{ color: 'gray' }} />;
                            title = 'Prioridade: Comum';
                            break;
                        case 1:
                            icon = <WarningIcon sx={{ color: 'orange' }} />;
                            title = 'Prioridade: Urgente';
                            break;
                        case 2:
                            icon = <PriorityHighIcon sx={{ color: 'red' }} />;
                            title = 'Prioridade: Priorizar';
                            break;
                        default:
                            icon = null;
                            title = 'Prioridade não definida';
                    }

                    return <Tooltip title={title}>{icon}</Tooltip>;
                },
            },
            {
                accessorFn: (row) => row.tipo_ordem,
                id: 'tipo_ordem',
                header: '📄',
                size: 50,

                // 🔹 Permite filtrar pelo texto digitado
                filterFn: (row, columnId, filterValue) => {
                    if (!filterValue) return true;
                    const tipo = row.getValue(columnId);

                    let textoTipo = '';
                    switch (tipo) {
                        case 0:
                            textoTipo = 'ordem de compra';
                            break;
                        case 1:
                            textoTipo = 'solicitação de pagamento';
                            break;
                        default:
                            textoTipo = 'não definido';
                    }

                    return textoTipo.toLowerCase().includes(filterValue.toLowerCase());
                },

                // 🔹 Renderiza o ícone normalmente
                Cell: ({ renderedCellValue }) => {
                    let icon = null;
                    let title = '';

                    switch (renderedCellValue) {
                        case 0:
                            icon = <ShoppingCartIcon sx={{ color: 'blue' }} />;
                            title = 'Ordem de Compra';
                            break;
                        case 1:
                            icon = <PaidIcon sx={{ color: 'green' }} />;
                            title = 'Solicitação de Pagamento';
                            break;
                        default:
                            icon = <HelpOutlineIcon sx={{ color: 'gray' }} />;
                            title = 'Tipo não definido';
                    }

                    return <Tooltip title={title}>{icon}</Tooltip>;
                },
            },
            {
                accessorFn: (row) => STATUS_TEXT[String(row.status)] || "Status não identificado",
                id: 'status',
                header: '📌',
                size: 50,
                filterFn: 'includesString',
                Cell: ({ row, renderedCellValue }) => {
                    const preCotacoes = row.original.pre_cotacoes || [];
                    const status = row.original.status;

                    let totalGeral = 0;
                    let pagoGeral = 0;

                    // ✅ Apenas considerar lançamentos válidos (>0)
                    const lancamentosValidos = preCotacoes.filter(pc => {
                        const valor = pc.lancamento?.valor ?? 0;
                        return pc.lancamento?.id_lancamento > 0 && valor > 0;
                    });

                    lancamentosValidos.forEach(pc => {
                        const lanc = pc.lancamento;
                        totalGeral += lanc?.valor ?? 0;
                        pagoGeral += lanc?.valor_pago_concluido ?? 0;
                    });

                    const restanteTotal = totalGeral - pagoGeral;
                    const todasLancadasComValor = lancamentosValidos.length === preCotacoes.length && lancamentosValidos.length > 0;
                    const algumaLancada = lancamentosValidos.length > 0;

                    // ⚙️ Status base
                    let statusFinanceiro = renderedCellValue;

                    if (status >= 3 && status !== 9) {
                        if (todasLancadasComValor && restanteTotal === 0) {
                            statusFinanceiro = 'Faturado | Pagamento Concluído';
                        } else if (algumaLancada && restanteTotal > 0 && restanteTotal < totalGeral) {
                            statusFinanceiro = 'Em Faturamento | Pagamento em Andamento';
                        } else {
                            statusFinanceiro = 'Autorizado, em Faturamento';
                        }
                    }
                    // Se status < 3, mantém o original (Editando, Aguardando Autorização, etc.)
                    // Se status == 9, segue como Cancelado (já tratado no STATUS_TEXT)

                    const customTooltip = (
                        <div style={{ backgroundColor: darkMode ? '#1e1e1e' : 'white', width: 700, color: darkMode ? 'white' : 'black', border: darkMode ? '1px solid #444' : '2px solid black', padding: 8, fontSize: 18 }}>
                            <h6>Status das Autorizações</h6>
                            {row.original.autorizacoes?.length
                                ? row.original.autorizacoes.map((aut, idx) => <div key={idx}>• {aut.status}</div>)
                                : <div>Nenhuma autorização encontrada</div>}
                        </div>
                    );

                    const idUsuarioLogado = Cookies.get("id_usuario");
                    const shouldBlink = row.original.autorizacoes?.some(
                        aut => String(aut.id_usuario) === String(idUsuarioLogado) && aut.autorizado === 0
                    );

                    if (shouldBlink && !document.getElementById('blink-keyframes')) {
                        const styleTag = document.createElement('style');
                        styleTag.id = 'blink-keyframes';
                        styleTag.innerHTML = `
                @keyframes blink {
                    0% { background-color: transparent; }
                    50% { background-color: yellow; }
                    100% { background-color: transparent; }
                }
            `;
                        document.head.appendChild(styleTag);
                    }

                    let icon;
                    switch (status) {
                        case 0: icon = <EditNoteIcon sx={{ color: 'gray' }} />; break;
                        case 1: icon = <HourglassTopIcon sx={{ color: 'orange' }} />; break;
                        case 2: icon = <TaskIcon sx={{ color: '#1976d2' }} />; break;
                        case 3: icon = <AssignmentTurnedInIcon sx={{ color: 'green' }} />; break;
                        case 4: icon = <CheckCircleIcon sx={{ color: 'limegreen' }} />; break;
                        case 9: icon = <CancelIcon sx={{ color: 'red' }} />; break;
                        case -2: icon = <InventoryIcon sx={{ color: 'green' }} />; break;
                        default: icon = null;
                    }

                    return (
                        <Tooltip title={customTooltip}>
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 4,
                                    animation: shouldBlink ? "blink 1s infinite" : "none",
                                }}
                            >
                                {icon}
                                {statusFinanceiro}
                            </span>
                        </Tooltip>
                    );
                },
            },



            {
                accessorFn: (row) => row.usuario?.nome_amigavel || '',
                id: 'usuario',
                header: 'Usuário Criador',
                size: 130,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                header: 'Descrição',
                accessorKey: 'descricao',
                size: 300,
                accessorFn: (row) => row.descricao,
                Cell: ({ cell }) => (
                    <div style={{ wordBreak: 'break-all' }}>
                        {cell.getValue()}
                    </div>
                ),
            },

            {
                accessorKey: 'valor_total',
                header: 'Valor Total',
                size: 50,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value != null
                        ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                        : '-';
                },
                Footer: ({ table }) => {
                    const total = table
                        .getRowModel()
                        .rows.reduce((sum, row) => {
                            const status = row.original.status;
                            const valor = row.getValue('valor_total');
                            // 🔹 Soma apenas se status >= 3 e status != 9
                            if (status >= 3 && status !== 9) {
                                return sum + (valor || 0);
                            }
                            return sum;
                        }, 0);

                    return (
                        <span
                            style={{
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                                display: 'block',
                                textAlign: 'right',
                                color: darkMode ? '#fff' : '#000',
                            }}
                        >
                            {total.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </span>
                    );
                },
            },
            {
                accessorFn: (row) => row.pre_cotacoes || [],
                id: 'financeiroadmin',
                header: 'Financeiro',
                size: 350,
                enableColumnFilter: true, // habilita filtro
                filterFn: (row, columnId, filterValue) => {
                    const preCotacoes = row.getValue(columnId) || [];
                    // compara filtro com id_pre_cotacao ou nome do método de pagamento
                    return preCotacoes.some(pc =>
                        pc.id_pre_cotacao.toString().includes(filterValue) ||
                        pc.metodo_pagamento?.nome?.toLowerCase().includes(filterValue.toLowerCase()) ||
                        (pc.historico_financeiro && pc.historico_financeiro.toLowerCase().includes(filterValue.toLowerCase()))
                    );
                },
                Cell: ({ cell }) => {
                    const preCotacoes = cell.getValue();

                    if (!preCotacoes || preCotacoes.length === 0) return "-";

                    return (
                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                            {preCotacoes.map((pc, index) => {
                                const lanc = pc.lancamento;
                                const historico = pc.historico_financeiro;
                                const idLancamento = lanc?.id_lancamento;
                                const total = lanc?.valor ?? 0;
                                const pago = lanc?.valor_pago_concluido ?? 0;
                                const restante = (total - pago) ?? 0;

                                if (!idLancamento) {
                                    if (regra.includes("ADMIN_FINAN")) {
                                        return (
                                            <span
                                                key={index}
                                                style={{ color: darkMode ? "#fff" : "blue", textDecoration: "underline", cursor: "pointer" }}
                                                onClick={() => gerarLancamento(pc.id_pre_cotacao)}
                                            >
                                                Na Compra ID {pc.id_pre_cotacao} não foi gerado lançamento | Método de Pagamento {pc.metodo_pagamento.nome}
                                            </span>
                                        );
                                    }

                                    const customTooltip = (
                                        <div
                                            style={{
                                                backgroundColor: darkMode ? '#1e1e1e' : 'white',
                                                height: '30vh',
                                                width: '50vw',
                                                overflow: 'auto',
                                                border: darkMode ? '1px solid #444' : '2px solid black',
                                                padding: '8px',
                                                color: darkMode ? 'white' : 'black',
                                                fontSize: 14,
                                            }}
                                        >
                                            <h6>Historico Financeiro</h6>
                                            {historico && historico.length > 0 ? (
                                                <div style={{ marginBottom: '4px' }}>
                                                    {"Na Compra ID " + pc.id_pre_cotacao + "\n\n" + historico}
                                                </div>
                                            ) : (
                                                <div>Sem mensagens na Compra ID {pc.id_pre_cotacao}</div>
                                            )}
                                        </div>
                                    );

                                    return (
                                        <Tooltip key={index} title={customTooltip} placement="left" arrow>
                                            <span style={{ color: "red" }}>
                                                Na Compra ID {pc.id_pre_cotacao} não foi gerado lançamento | Método de Pagamento {pc.metodo_pagamento.nome}
                                            </span>
                                        </Tooltip>
                                    );
                                }

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 8,
                                        }}
                                    >
                                        <span>
                                            #{idLancamento} | Total:{" "}
                                            {total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} |{" "}
                                            Pago: {pago.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} |{" "}
                                            Restante: {restante.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                            | Método de Pagamento: {pc.metodo_pagamento.nome}
                                        </span>

                                        <Tooltip title="Gerenciar Lançamento">
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() =>
                                                    window.open(
                                                        `/gestao/financas/lancamento/gerenciar/${idLancamento}`,
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                <OpenInNewIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                );
                            })}
                        </div>
                    );
                },
            },

            {
                accessorFn: (row) => row.pre_cotacoes || [],
                id: 'compras',
                header: 'Compras',
                size: 600,
                filterFn: (row, columnId, filterValue) => {
                    if (!filterValue) return true;
                    const termo = filterValue.toLowerCase();
                    const preCotacoes = row.getValue(columnId);
                    return preCotacoes.some(pc =>
                        pc.nome_fornecedor_amigavel?.toLowerCase().includes(termo)
                    );
                },
                Cell: ({ cell, row, table }) => {
                    const preCotacoes = cell.getValue();
                    const filterValue = table.getColumn('compras').getFilterValue() || '';
                    const termo = filterValue.toLowerCase();

                    const preCotacoesVisiveis = preCotacoes.filter(pc =>
                        !filterValue || pc.nome_fornecedor_amigavel?.toLowerCase().includes(termo)
                    );

                    const podeMostrarAcoes = row.original.status >= 3;

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {preCotacoesVisiveis.map((pc, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '6px 0',
                                        borderBottom: darkMode ? '1px solid #333' : '1px solid #eee',
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

                                        <Tooltip title="Gerenciar Fornecedor" arrow>
                                            <IconButton
                                                component="a"
                                                href={`/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/${pc.id_fornecedor}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                size="small"
                                            >
                                                <SettingsIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                            </IconButton>
                                        </Tooltip>



                                        {podeMostrarAcoes && (
                                            <>

                                                {pc.caminho_arquivo_compra && (
                                                    <Tooltip title="Arquivo da Ordem de Compra" arrow>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const link = pc.caminho_arquivo_compra.replaceAll(
                                                                    '/home/wwgrup/ordensdecompra/',
                                                                    'https://gruporosinetos.com/ocmidias/'
                                                                );
                                                                window.open(link, '_blank', 'noopener,noreferrer');
                                                            }}
                                                        >
                                                            {pc.caminho_arquivo_compra.toLowerCase().endsWith('.pdf') ? (
                                                                <img src={miniatura_pdf} alt="pdf" style={{ width: 18, height: 18 }} />
                                                            ) : (
                                                                <img src={office} alt="office" style={{ width: 18, height: 18 }} />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {pc.caminho_arquivo_fornecedor && (
                                                    <Tooltip title="Arquivo Original do Fornecedor" arrow>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const link = pc.caminho_arquivo_fornecedor.replaceAll(
                                                                    '/home/wwgrup/ordensdecompra/',
                                                                    'https://gruporosinetos.com/ocmidias/'
                                                                );
                                                                window.open(link, '_blank', 'noopener,noreferrer');
                                                            }}
                                                        >
                                                            {pc.caminho_arquivo_fornecedor.toLowerCase().endsWith('.pdf') ? (
                                                                <img src={miniatura_pdf} alt="pdf" style={{ width: 18, height: 18 }} />
                                                            ) : (
                                                                <img src={office} alt="office" style={{ width: 18, height: 18 }} />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {/* 📥 ENTRADA DE ESTOQUE */}
                                                {pc.id_entrada_estoque > 0 ? (
                                                    <Tooltip title="Gerenciar Entrada de Estoque" arrow>
                                                        <IconButton
                                                            component="a"
                                                            href={`/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/${pc.id_entrada_estoque}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            color="primary"
                                                            size="small"
                                                        >
                                                            <Inventory2Icon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                                            <SettingsIcon fontSize="inherit" sx={{ ml: 0.3, color: darkMode ? '#fff' : 'inherit' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Cadastrar Entrada de Estoque" arrow>
                                                        <IconButton
                                                            color="success"
                                                            size="small"
                                                            onClick={() => gerarEntradaEstoque(pc.id_pre_cotacao)}
                                                        >
                                                            <Inventory2OutlinedIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                                            <AddCircleOutlineIcon fontSize="inherit" sx={{ ml: 0.3, color: darkMode ? '#fff' : 'inherit' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {/* 📤 SAÍDA DE ESTOQUE */}
                                                {row.original.id_saida_estoque > 0 ? (
                                                    <Tooltip title="Gerenciar Saída de Estoque" arrow>
                                                        <IconButton
                                                            component="a"
                                                            href={`/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/${row.original.id_saida_estoque}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            color="warning"
                                                            size="small"
                                                        >
                                                            <OutboundIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                                            <SettingsIcon fontSize="inherit" sx={{ ml: 0.3, color: darkMode ? '#fff' : 'inherit' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Cadastrar Saída de Estoque" arrow>
                                                        <IconButton
                                                            color="error"
                                                            size="small"
                                                            onClick={() => gerarSaidaEstoque(row.original.id_ordem_compra)}
                                                        >
                                                            <OutboundOutlinedIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                                            <AddCircleOutlineIcon fontSize="inherit" sx={{ ml: 0.3, color: darkMode ? '#fff' : 'inherit' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        )}


                                        <span style={{ fontWeight: 500, fontSize: 13, color: darkMode ? '#fff' : '#333' }}>
                                            {pc.nome_fornecedor_amigavel}
                                        </span>
                                    </div>


                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end',
                                            gap: 4,
                                            fontWeight: 600,
                                            color: darkMode ? '#fff' : '#000',
                                            minWidth: 120,
                                        }}
                                    >
                                        <AttachMoneyIcon sx={{ fontSize: 16, color: darkMode ? '#fff' : '#000' }} />
                                        <span>
                                            {pc.valor_total?.toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL',
                                            }) || '-'}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    );
                },
                Footer: ({ table, column }) => {
                    const filterValue = table.getColumn('compras').getFilterValue() || '';
                    const termo = filterValue.toLowerCase();

                    const total = table.getFilteredRowModel().rows.reduce((acc, row) => {
                        const status = row.original.status;

                        // 🔹 Ignora linhas com status < 3 ou canceladas (9)
                        if (status < 3 || status === 9) return acc;

                        const preCotacoes = row.getValue(column.id);
                        const preCotacoesVisiveis = preCotacoes.filter(pc =>
                            !filterValue || pc.nome_fornecedor_amigavel?.toLowerCase().includes(termo)
                        );

                        const somaLinha = preCotacoesVisiveis.reduce(
                            (soma, pc) => soma + (pc.valor_total || 0),
                            0
                        );

                        return acc + somaLinha;
                    }, 0);

                    return (
                        <div
                            style={{
                                fontWeight: 600,
                                color: darkMode ? '#fff' : '#000',
                                textAlign: 'left',
                                paddingLeft: 8,
                            }}
                        >
                            Total: {total.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </div>
                    );
                },
            },

            {
                accessorKey: 'data_criacao',
                header: 'Data Criação',
                size: 130,
                filterFn: (row, columnId, filterValue) => {
                    if (!filterValue) return true; // sem filtro
                    const cellValue = row.getValue(columnId);
                    if (!cellValue) return false;

                    // converte para objeto Date
                    const data = new Date(cellValue);
                    if (isNaN(data)) return false;

                    // tenta extrair mês/ano do valor digitado
                    const [mes, ano] = filterValue.split('/').map((v) => parseInt(v, 10));
                    if (!mes || !ano) return false;

                    const mesCell = data.getMonth() + 1;
                    const anoCell = data.getFullYear();

                    // compara apenas mês/ano
                    return mesCell === mes && anoCell === ano;
                },
                Cell: ({ renderedCellValue }) => (
                    <span>{formatDate(renderedCellValue)}</span>
                ),
            },
            {
                accessorFn: (row) =>
                    row.solicitantes?.map((s) => s.nome_amigavel).join(', ') || '',
                id: 'solicitantes',
                header: 'Solicitantes',
                size: 250,
                Cell: ({ cell, row }) => {
                    const solicitantes = cell.getValue();
                    const idOrdemServico = row.original.id_ordem_servico;

                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                            <span>
                                {solicitantes}
                                {idOrdemServico && idOrdemServico > 0
                                    ? ` através da O.S nº ${idOrdemServico}`
                                    : ''}
                            </span>

                            {idOrdemServico && idOrdemServico > 0 && (
                                <Tooltip title="Abrir Ordem de Serviço" arrow>
                                    <IconButton
                                        component="a"
                                        href={`/gestao/administracao/ordensdeservicos/editar/${idOrdemServico}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                    >
                                        <SettingsIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    );
                },
            },
            {
                accessorFn: (row) => row.pre_cotacoes || [],
                id: 'financeiro',
                header: 'Financeiro',
                size: 350,
                enableColumnFilter: true, // habilita filtro
                filterFn: (row, columnId, filterValue) => {
                    const preCotacoes = row.getValue(columnId) || [];
                    // compara filtro com id_pre_cotacao ou nome do método de pagamento
                    return preCotacoes.some(pc =>
                        pc.id_pre_cotacao.toString().includes(filterValue) ||
                        pc.metodo_pagamento?.nome?.toLowerCase().includes(filterValue.toLowerCase()) ||
                        (pc.historico_financeiro && pc.historico_financeiro.toLowerCase().includes(filterValue.toLowerCase()))
                    );
                },
                Cell: ({ cell }) => {
                    const preCotacoes = cell.getValue();

                    if (!preCotacoes || preCotacoes.length === 0) return "-";

                    return (
                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                            {preCotacoes.map((pc, index) => {
                                const lanc = pc.lancamento;
                                const historico = pc.historico_financeiro;
                                const idLancamento = lanc?.id_lancamento;
                                const total = lanc?.valor ?? 0;
                                const pago = lanc?.valor_pago_concluido ?? 0;
                                const restante = (total - pago) ?? 0;

                                if (!idLancamento) {
                                    if (regra.includes("ADMIN_FINAN")) {
                                        return (
                                            <span
                                                key={index}
                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                onClick={() => gerarLancamento(pc.id_pre_cotacao)}
                                            >
                                                Na Compra ID {pc.id_pre_cotacao} não foi gerado lançamento | Método de Pagamento {pc.metodo_pagamento.nome}
                                            </span>
                                        );
                                    }

                                    const customTooltip = (
                                        <div
                                            style={{
                                                backgroundColor: darkMode ? '#1e1e1e' : 'white',
                                                height: '30vh',
                                                width: '50vw',
                                                overflow: 'auto',
                                                border: darkMode ? '1px solid #444' : '2px solid black',
                                                padding: '8px',
                                                color: darkMode ? 'white' : 'black',
                                                fontSize: 14,
                                            }}
                                        >
                                            <h6>Historico Financeiro</h6>
                                            {historico && historico.length > 0 ? (
                                                <div style={{ marginBottom: '4px' }}>
                                                    {"Na Compra ID " + pc.id_pre_cotacao + "\n\n" + historico}
                                                </div>
                                            ) : (
                                                <div>Sem mensagens na Compra ID {pc.id_pre_cotacao}</div>
                                            )}
                                        </div>
                                    );

                                    return (
                                        <Tooltip key={index} title={customTooltip} placement="left" arrow>
                                            <span style={{ color: "red" }}>
                                                Na Compra ID {pc.id_pre_cotacao} não foi gerado lançamento | Método de Pagamento {pc.metodo_pagamento.nome}
                                            </span>
                                        </Tooltip>
                                    );
                                }

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 8,
                                        }}
                                    >
                                        <span>
                                            #{idLancamento} | Total:{" "}
                                            {total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} |{" "}
                                            Pago: {pago.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} |{" "}
                                            Restante: {restante.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                            | Método de Pagamento: {pc.metodo_pagamento.nome}
                                        </span>

                                        <Tooltip title="Gerenciar Lançamento">
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() =>
                                                    window.open(
                                                        `/gestao/financas/lancamento/gerenciar/${idLancamento}`,
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                <OpenInNewIcon fontSize="small" sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                );
                            })}
                        </div>
                    );
                },
            },

            {
                accessorKey: 'data_hora_maxima_conclusao',
                header: 'Data Máxima Conclusão',
                size: 130,
                Cell: ({ renderedCellValue }) => (
                    <span>{formatDate(renderedCellValue)}</span>
                ),
            },

        ],
        [darkMode],
    );



    const backgroundColorPage = darkMode ? '#121212' : 'white';


    const [openAviso, setOpenAviso] = useState(false);

    const handleCopyLink = (id) => {
        const link = `https://gruporosinetos.com/gestao/administracao/ordensdecompras/editar/${id}`;
        navigator.clipboard.writeText(link);
        setOpenAviso(true); // mostra o toast
    };


    function RowActions({ row, isMobile, handleClickRemover, handleCopyLink, handleClickReforcarAutorizacao, handleClickClonar }) {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);

        const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
        const handleMenuClose = () => setAnchorEl(null);

        return (
            <Box
                sx={{
                    display: 'flex',
                    gap: '1rem',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                <Tooltip title="Gerenciar">
                    <a
                        href={`/gestao/administracao/ordensdecompras/editar/${row.original.id_ordem_compra}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                    >
                        <IconButton color="primary">
                            <SettingsIcon sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                        </IconButton>
                    </a>
                </Tooltip>

                {!isMobile && (
                    <Tooltip title="Mais Ações">
                        <IconButton color="primary" onClick={handleMenuOpen}>
                            <MoreVertIcon sx={{ color: darkMode ? '#fff' : 'inherit' }} />
                        </IconButton>
                    </Tooltip>
                )}

                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    {row.original.status <= 2 && (
                        <MenuItem
                            onClick={() => {
                                handleClickRemover(row.original);
                                handleMenuClose();
                            }}
                        >
                            <Delete fontSize="small" sx={{ mr: 1, color: darkMode ? '#fff' : 'inherit' }} />
                            Excluir
                        </MenuItem>
                    )}

                    <MenuItem
                        onClick={() => {
                            handleCopyLink(row.original.id_ordem_compra);
                            handleMenuClose();
                        }}
                    >
                        <LinkIcon fontSize="small" sx={{ mr: 1, color: darkMode ? '#fff' : 'inherit' }} />
                        Copiar Link
                    </MenuItem>

                    {row.original.status === 2 && (
                        <MenuItem
                            onClick={() => {
                                handleClickReforcarAutorizacao(row.original.id_ordem_compra);
                                handleMenuClose();
                            }}
                        >
                            <VerifiedIcon fontSize="small" sx={{ mr: 1 }} color="success" />
                            Reforçar Autorização
                        </MenuItem>
                    )}

                    <MenuItem
                        onClick={() => {
                            handleClickClonar(row.original.id_ordem_compra);
                            handleMenuClose();
                        }}
                    >
                        <ContentCopyIcon fontSize="small" sx={{ mr: 1 }} color="success" />
                        Clonar
                    </MenuItem>
                </Menu>
            </Box>
        );
    }

    const table = useMaterialReactTable({
        columns,
        data: objetos,
        enableBottomToolbar: !isMobile,
        enableGlobalFilterModes: true,
        enableGlobalFilter: false,
        enablePagination: !isMobile,
        enableRowActions: true,
        paginationDisplayMode: 'pages',
        manualPagination: true,
        rowCount: totalRegistros,
        state: { pagination },
        onPaginationChange: !isMobile ? setPagination : undefined,
        getRowId: (row) => row.id_ordem_compra,
        enableGrouping: true,
        initialState: {
            showGlobalFilter: true,
            showColumnFilters: !isMobile,
            columnVisibility: isMobile
                ? {
                    id_ordem_compra: !isMobile,
                    status: true,
                    nivel_prioridade: false,
                    usuario: false,
                    descricao: false,
                    valor_total: false,
                    financeiro: false,
                    financeiroadmin: false,
                    data_criacao: false,
                    solicitantes: false,
                    compras: false,
                    data_hora_maxima_conclusao: false,
                }
                : {
                    nivel_prioridade: false,

                    financeiro: !regra.includes("ADMIN_FINAN"), // se for ADMIN_FINAN, mostra a coluna
                    financeiroadmin: regra.includes("ADMIN_FINAN"), // mostra só se não for ADMIN_FINAN


                },
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: `${tableHeight}px`,
                overflow: 'auto',
            },
        },

        muiTopToolbarProps: {
            sx: {
                bgcolor: darkMode ? '#121212' : 'background.default',
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiSvgIcon-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiInputBase-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                }
            },
        },

        muiBottomToolbarProps: {
            sx: {
                bgcolor: darkMode ? '#121212' : 'background.default',
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiSvgIcon-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiTablePagination-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                }
            },
        },
        enableStickyHeader: !isMobile,
        muiPaginationProps: {
            rowsPerPageOptions: [30, 50, 100, 200, 400, 1000],
            variant: 'outlined',
        },
        muiTableHeadCellProps: {
            sx: {
                padding: '4px',
                fontSize: '0.75rem',
                lineHeight: 1,
                height: '28px',
                backgroundColor: darkMode ? '#000 !important' : '#fff !important',
                color: darkMode ? '#fff !important' : '#000 !important',
                display: isMobile ? 'none' : 'table-cell',
                '& .Mui-TableHeadCell-Content-Labels': {
                    color: darkMode ? '#fff !important' : '#000 !important',
                },
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },
                '& .MuiInputBase-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                }
            },
        },
        muiTableHeadRowProps: {
            sx: {
                backgroundColor: darkMode ? '#000 !important' : '#fff !important',
            },
        },
        muiTableFilterRowProps: {
            sx: {
                backgroundColor: darkMode ? '#000 !important' : '#fff !important',
            },
        },
        muiTableBodyCellProps: {
            sx: {
                padding: '4px',
                fontSize: '0.75rem',
                lineHeight: 1.2,
                color: darkMode ? '#fff' : '#222',
            },
        },
        muiTableBodyRowProps: ({ row }) => ({
            sx: {
                height: '14px',
                backgroundColor: row.index % 2 === 0 ? (darkMode ? '#1e1e1e' : '#f9f9f9') : (darkMode ? '#2d2d2d' : '#e0e0e0'),
                transition: 'background-color 0.3s',
                '&:hover': {
                    backgroundColor: darkMode ? '#333' : '#d0f0ff',
                },
            },
        }),

        muiTablePaginationProps: {
            sx: {
                backgroundColor: darkMode ? '#121212' : '#f9f9f9',

                // Texto "Rows per page"
                '& .MuiTablePagination-selectLabel': {
                    color: darkMode ? '#fff' : 'inherit',
                },

                // Texto "1–30 of 200"
                '& .MuiTablePagination-displayedRows': {
                    color: darkMode ? '#fff' : 'inherit',
                },

                // Texto selecionado (30, 50, 100...)
                '& .MuiSelect-select': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },

                // Ícone da setinha do select
                '& .MuiSelect-icon': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },

                // Botões de paginação (<< < > >>)
                '& .MuiIconButton-root': {
                    color: darkMode ? '#fff !important' : 'inherit',
                },

                // Botões desabilitados
                '& .Mui-disabled': {
                    color: darkMode
                        ? 'rgba(255,255,255,0.3) !important'
                        : 'rgba(0,0,0,0.3)',
                },
            },
        },


        renderTopToolbarCustomActions: () => (
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: isMobile ? 1 : 2,
                flexWrap: isMobile ? 'nowrap' : 'wrap',
                overflowX: isMobile ? 'auto' : 'visible',
                p: '4px',
                width: '100%',
                justifyContent: isMobile ? 'space-between' : 'flex-start',
                '&::-webkit-scrollbar': { display: 'none' }, // esconde scrollbar no mobile
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? 0.5 : 2, flexWrap: 'nowrap' }}>
                    <FormControlLabel
                        sx={{ m: 0, mr: isMobile ? 0.5 : 1 }}
                        control={<Checkbox size="small" sx={{ p: isMobile ? 0.5 : 1 }} checked={regra.includes("ADMIN_OC_MINHAS_OCS") ? true : filtroChecked} disabled={regra.includes("ADMIN_OC_MINHAS_OCS")} onChange={(e) => handleFiltroChecked(e.target.checked)} />}
                        label={<Typography variant="caption" sx={{ fontSize: isMobile ? '0.65rem' : '0.75rem', whiteSpace: 'nowrap' }}>Minhas</Typography>}
                    />
                    <FormControlLabel
                        sx={{ m: 0, mr: isMobile ? 0.5 : 1 }}
                        control={<Checkbox size="small" sx={{ p: isMobile ? 0.5 : 1 }} checked={abertasChecked} onChange={(e) => handleAbertasChecked(e.target.checked)} />}
                        label={<Typography variant="caption" sx={{ fontSize: isMobile ? '0.65rem' : '0.75rem', whiteSpace: 'nowrap' }}>Abertas</Typography>}
                    />
                    <FormControlLabel
                        sx={{ m: 0, mr: isMobile ? 0.5 : 1 }}
                        control={<Checkbox size="small" sx={{ p: isMobile ? 0.5 : 1 }} checked={aguardandoChecked} onChange={(e) => handleAguardandoChecked(e.target.checked)} />}
                        label={<Typography variant="caption" sx={{ fontSize: isMobile ? '0.65rem' : '0.75rem', whiteSpace: 'nowrap' }}>Pendentes</Typography>}
                    />
                    <FormControlLabel
                        sx={{ m: 0, mr: isMobile ? 0.5 : 1 }}
                        control={<Checkbox size="small" sx={{ p: isMobile ? 0.5 : 1 }} checked={regra.includes("ADMIN_OC_AUTORIZADAS") ? true : autorizadasChecked} onChange={(e) => handleAutorizadasChecked(e.target.checked)} disabled={regra.includes("ADMIN_OC_AUTORIZADAS")} />}
                        label={<Typography variant="caption" sx={{ fontSize: isMobile ? '0.65rem' : '0.75rem', whiteSpace: 'nowrap' }}>Autorizadas</Typography>}
                    />
                </Box>

                {isMobile ? (
                    <Tooltip title="Nova Ordem de Compra" arrow>
                        <IconButton
                            color="primary"
                            onClick={novo}
                            sx={{
                                bgcolor: 'primary.main',
                                color: 'white',
                                '&:hover': { bgcolor: 'primary.dark' },
                                width: 32,
                                height: 32,
                                borderRadius: 1
                            }}
                        >
                            <AddCircleOutlineIcon sx={{ fontSize: 24 }} />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Button variant="contained" color="primary" size="small" onClick={novo}>Nova Ordem de Compra</Button>
                )}
            </Box>
        ),
        enableFullScreenToggle: !isMobile,
        renderRowActions: ({ row }) => (
            <RowActions
                row={row}
                isMobile={isMobile}
                handleClickRemover={handleClickRemover}
                handleCopyLink={handleCopyLink}
                handleClickReforcarAutorizacao={handleClickReforcarAutorizacao}
                handleClickClonar={handleClickClonar}
            />
        ),
        muiExpandButtonProps: {
            sx: { width: '20px', minWidth: '20px' },
        },
        displayColumnDefOptions: {
            'mrt-row-expand': {
                size: 30,
                minSize: 30,
                maxSize: 30,
            },
            'mrt-row-actions': {
                size: 60,        // ajuste para o tamanho ideal
                minSize: 60,
                maxSize: 60,
            },
        },
        renderDetailPanel: ({ row }) =>
            isMobile && (
                <Grid container spacing={2} sx={{ p: 2 }}>
                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ p: 2, bgcolor: darkMode ? '#1e1e1e' : '#fafafa', color: darkMode ? '#fff' : 'inherit' }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Informações Gerais
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Typography><b>Criador:</b> {row.original.usuario?.nome_amigavel}</Typography>
                            <Typography><b>Solicitantes:</b> {row.original.solicitantes?.map(s => s.nome_amigavel).join(', ') || '-'}</Typography>
                            <Typography><b>Descrição:</b> {row.original.descricao}</Typography>
                            <Typography>
                                <b>Valor Total:</b>{' '}
                                {row.original.valor_total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || '-'}
                            </Typography>
                            <Typography><b>Data Criação:</b> {formatDate(row.original.data_criacao)}</Typography>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ p: 2, bgcolor: darkMode ? '#1e1e1e' : '#fdfdfd', color: darkMode ? '#fff' : 'inherit' }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Assinaturas / Autorizações
                            </Typography>
                            <Divider sx={{ mb: 1 }} />

                            {row.original.autorizacoes && row.original.autorizacoes.length > 0 ? (
                                <List dense>
                                    {row.original.autorizacoes.map((aut, idx) => {
                                        let icon = <EditNoteIcon sx={{ color: 'gray' }} />;
                                        let color = 'gray';

                                        if (aut.autorizado === 1) {
                                            icon = <CheckCircleIcon sx={{ color: 'green' }} />;
                                            color = 'green';
                                        } else if (aut.autorizado === 0) {
                                            icon = <HourglassTopIcon sx={{ color: 'orange' }} />;
                                            color = darkMode ? '#fff' : 'black';
                                        } else if (aut.autorizado === 9) {
                                            icon = <CancelIcon sx={{ color: 'red' }} />;
                                            color = 'red';
                                        } else if (aut.autorizado === -2) {
                                            icon = <InventoryIcon sx={{ color: 'red' }} />;
                                            color = 'green';
                                        }

                                        return (
                                            <ListItem key={idx} sx={{ py: 0.5 }}>
                                                <ListItemIcon>{icon}</ListItemIcon>
                                                <ListItemText
                                                    primary={<span style={{ color }}>{`Status: ${aut.status}`}</span>}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    Nenhuma autorização encontrada
                                </Typography>
                            )}
                        </Card>
                    </Grid>

                    {row.original.autorizacoes?.some(
                        (aut) =>
                            parseInt(aut.id_usuario, 10) === parseInt(Cookies.get('id_usuario'), 10) &&
                            parseInt(aut.autorizado, 10) === 0
                    ) && row.original.status === 2 && (
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                                item
                                xs={6}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={(e) => handleOpenAutorizar(row.original.id_ordem_compra)}
                                >
                                    Autorizar
                                </Button>
                            </Grid>
                        )}
                </Grid>
            ),
    });





    useEffect(() => {
        if (!objetos || objetos.length === 0) return;

        const visiveis = table.getRowModel().rows.map(r => r.original);

        let abertas = visiveis.filter(d => d.status <= 1).length;
        let aguardando = visiveis.filter(d => d.status === 2).length;
        let solicitante = visiveis.filter(d =>
            d.solicitantes?.some(s => parseInt(s.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10))
        ).length;
        let autorizador = visiveis.filter(d =>
            d.autorizacoes?.some(a => parseInt(a.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10))
        ).length;

        setNumOrdensAbertas(abertas);
        setNumOrdensAguardando(aguardando);
        setNumOrdensSolicitante(solicitante);
        setNumOrdensAutorizador(autorizador);
    }, [table.getState().columnFilters, table.getState().globalFilter, objetos]);





    const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

    return (
        <div style={{
            backgroundColor: darkMode ? '#121212' : backgroundColorPage,
            height: '100vh',
            color: darkMode ? 'white' : 'black',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto'
        }}>
            {/* Navegador */}

            <NavegadorGestao
                Gestao={true}
                OrdensCompras={true}
                corFundo={darkMode ? '#1e1e1e' : 'white'}
                travado={true}
                corTexto={darkMode ? 'white' : 'black'}
            />


            {/* Área da Tabela */}
            {value === 0 && (
                <div
                    style={{
                        paddingTop: 5,
                        paddingLeft: isMobile ? 10 : !isMobile && open ? 230 : 50,
                        width: '100%',
                        backgroundColor: darkMode ? '#121212' : backgroundColorPage,
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'auto'
                    }}

                >
                    {!regra.includes("ADMIN_OC_MINHAS_OCS")
                        ?
                        <DashboardGeral darkMode={darkMode} />
                        : <span>Nada aqui!</span>
                    }


                </div>
            )}

            {value === 1 && (
                <OrdemCompraComponente
                    ref={ordemCompraRef}
                    idProposta={0}
                    idColaborador={0}
                    idFornecedor={0}
                />
            )}


            {/* Drawer */}
            {/* Drawer */}
            {isMobile && !open && (
                <div
                    onClick={() => setOpen(true)}
                    onTouchStart={(e) => {
                        touchStartRef.current = e.touches[0].clientX;
                    }}
                    onTouchMove={(e) => {
                        if (touchStartRef.current === null) return;
                        const touchCurrentX = e.touches[0].clientX;
                        if (touchCurrentX - touchStartRef.current > 10) { // Threshold de 10px para considerar swipe
                            setOpen(true);
                            touchStartRef.current = null; // Reset para evitar múltiplos triggers
                        }
                    }}
                    onTouchEnd={() => {
                        touchStartRef.current = null;
                    }}
                    style={{
                        position: 'fixed',
                        left: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: '20px', // Aumentado para facilitar o toque/drag
                        height: '60px',
                        backgroundColor: darkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)',
                        borderRadius: '0 8px 8px 0',
                        zIndex: 1300,
                        cursor: 'pointer',
                        backdropFilter: 'blur(2px)',
                        boxShadow: '1px 0 4px rgba(0,0,0,0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        touchAction: 'none' // Importante para o navegador não tentar scrollar
                    }}
                >
                    <div style={{ width: '4px', height: '25px', backgroundColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)', borderRadius: '2px' }} />
                </div>
            )}

            {isMobile ? (
                <SwipeableDrawer
                    open={open}
                    onClose={() => setOpen(false)}
                    onOpen={() => setOpen(true)}
                    swipeAreaWidth={80}
                    disableDiscovery={false}
                    disableBackdropTransition={!iOS}
                    SwipeAreaProps={{
                        onClick: () => setOpen(true), // Catch click that passed through handle
                        style: { zIndex: 1200 } // Ensure SwipeArea is above content to catch swipes
                    }}
                    anchor="left"
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: 230,
                            bgcolor: darkMode ? '#1e1e1e' : '#f0f8ff',
                            color: darkMode ? '#fff' : '#000',
                            zIndex: 1300,
                        },
                    }}
                >
                    <List>
                        <ListItem
                            button
                            onClick={() => {
                                handleMenuClick(0);
                                setOpen(false);
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <DashboardIcon sx={{ fontSize: 28, color: '#1976d2' }} />
                            </ListItemIcon>
                            <ListItemText primary="Dashboard" sx={{ color: darkMode ? '#fff' : '#222' }} />
                        </ListItem>

                        <ListItem
                            button
                            onClick={() => {
                                handleMenuClick(1);
                                setOpen(false);
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <PostAddIcon sx={{ fontSize: 28, color: '#d32f2f' }} />
                            </ListItemIcon>
                            <ListItemText primary="Ordens de Compras" sx={{ color: darkMode ? '#fff' : '#222' }} />
                        </ListItem>
                    </List>
                </SwipeableDrawer>
            ) : (
                <Drawer
                    variant="permanent"
                    open={open}
                    anchor="left"
                    sx={{
                        '& .MuiDrawer-paper': {
                            top: '80px',
                            height: 'calc(100vh - 100px)',
                            width: open ? 230 : 50,
                            transition: 'width 0.3s',
                            overflowX: 'hidden',
                            bgcolor: darkMode ? '#1e1e1e' : '#f0f8ff',
                            color: darkMode ? '#fff' : '#000',
                        },
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ alignSelf: 'flex-end', m: 1 }}>
                        {open ? <ChevronLeftIcon sx={{ color: '#1976d2' }} /> : <ChevronRightIcon sx={{ color: '#1976d2' }} />}
                    </IconButton>

                    <List>
                        <ListItem
                            button
                            onClick={() => handleMenuClick(0)}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <DashboardIcon sx={{ fontSize: 28, color: '#1976d2' }} />
                            </ListItemIcon>
                            {open && <ListItemText primary="Dashboard" sx={{ color: darkMode ? '#fff' : '#222' }} />}
                        </ListItem>

                        <ListItem
                            button
                            onClick={() => handleMenuClick(1)}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <PostAddIcon sx={{ fontSize: 28, color: '#d32f2f' }} />
                            </ListItemIcon>
                            {open && <ListItemText primary="Ordens de Compras" sx={{ color: darkMode ? '#fff' : '#222' }} />}
                        </ListItem>
                    </List>
                </Drawer>
            )}


        </div>
    );
}



